import React from "react";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../Timps/Switch/style";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import AirBrakeReport_A from "./AirBrakeReports/AirBrakeReport_A";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import AirBrakeReport_B from "./AirBrakeReports/AirBrakeReport_B";
import AirBrakeReport_C from "./AirBrakeReports/AirBrakeReport_C";
import AirBrakeAFM92Days from "./AirBrakeReports/AirBrakeAFM92Days";
import CLMB_AirBrakeLvlOne from "./AirBrakeReports/CLMB/AirBrakeReportLevelOne";
import reportByVersion from "../../utils/reportVersions";

export const AirBrakeReports = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ReportView data={{}} />;
  }
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let grouped = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, [
    "AirBrakeAFM92Days",
    "AirBrakeAFMLevelOne",
    "AirBrakeSys1Lvl2",
    "AirBrakeSys2Lvl2",
    "AirBrakeSys3Lvl2",
    "AirBrakeSys4Lvl2",
    "AirBrakeSys1Lvl3",
    "AirBrakeSys2Lvl3",
    "AirBrakeSys3Lvl3",
    "AirBrakeSys4Lvl3",
  ]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(grouped);
  return decodedReports.map((report, i) => {
    return <ReportView key={i} data={report} {...props} />;
  });
};

const ReportView = (props) => {
  const { data, title } = props;
  const { decodedData } = data;

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title={title} fontSizeOverride={"35px"} />
      <ReportFraInfoSectionContainer {...props} />
      {decodedData.map((singleReport, index) => {
        const { testCode, otherInfo } = singleReport;
        let version = (otherInfo || {}).ver || "default";
        switch (testCode) {
          case "AirBrakeAFMLevelOne": {
            let LvlOneReport = reportByVersion(version, testCode);
            return <LvlOneReport singleReport={singleReport} key={index} />;
          }
          case "AirBrakeSys1Lvl2":
          case "AirBrakeSys2Lvl2":
          case "AirBrakeSys3Lvl2":
          case "AirBrakeSys4Lvl2": {
            //LevelTwoAirMaintenance368And736Days
            return <AirBrakeReport_B singleReport={singleReport} key={index} />;
          }

          case "AirBrakeSys1Lvl3":
          case "AirBrakeSys2Lvl3":
          case "AirBrakeSys3Lvl3": {
            //DetailedAirBrakeMaintenance
            return <AirBrakeReport_C singleReport={singleReport} key={index} />;
          }
          case "AirBrakeSys4Lvl3": {
            //DetailedAirBrakeMaintenance
            let Report = reportByVersion(version, testCode);
            return <Report singleReport={singleReport} key={index} />;
          }
          case "AirBrakeAFM92Days": {
            return <AirBrakeAFM92Days singleReport={singleReport} key={index} />;
          }

          default:
            null;
        }
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/AirBrakeReports/AirBrakeReport.jsx